import { Button, Stack, styled } from '@mui/material';
import { useMemo } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { routes } from 'src/Router/paths';
import { useAuthContext } from 'src/auth/useAuthContext';
import { Iconify } from 'src/components/iconify';
import { useLocales } from 'src/locales';

export const WizardLayout = () => {
  const { user } = useAuthContext();

  const navigate = useNavigate();

  const { pathname } = useLocation();

  const { translate } = useLocales();
  const { logout } = useAuthContext();

  const handleLogout = async () => {
    await logout();
  };

  const hideBack = useMemo(() => {
    return [routes.root, routes.dashboard.wizard.invite].includes(pathname);
  }, [pathname]);

  return (
    <Stack position="relative" width="100%" height="100%" overflow="auto">
      {!hideBack && (
        <FloatBtn
          size="small"
          color="inherit"
          className="left"
          variant="contained"
          startIcon={<Iconify icon="mdi:chevron-left" />}
          onClick={() => navigate(-1)}
        >
          {translate('shared.buttons.go_back')}
        </FloatBtn>
      )}
      {!user?.wizard?.completedWizard && (
        <FloatBtn
          size="small"
          color="inherit"
          className="right"
          variant="contained"
          startIcon={<Iconify icon="tabler:logout" />}
          onClick={handleLogout}
        >
          {translate('login.wizard.completed.logout_button')}
        </FloatBtn>
      )}
      <Outlet />
    </Stack>
  );
};

const FloatBtn = styled(Button)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(3),
  '&.left': { left: theme.spacing(3) },
  '&.right': { right: theme.spacing(3) },
}));
